<template>
  <div class="not-found">
    <div class="error-code"><svg-icon icon-class="404" /></div>
    <div class="error-message">抱歉，您访问的页面不存在</div>
    <router-link to="/" class="back-home">返回首页</router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  metaInfo: {
    title: '页面不存在 - 404'
  },
  mounted() {
    document.title = '页面不存在 - 404';
  }
}
</script>

<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 200px);
  text-align: center;
  padding: 0 20px 40px 20px;
}

.error-code {
  font-size: 600px;
  color: #333;
  margin-bottom: 20px;
  opacity: 0.8;
  line-height: 1;
}

.error-message {
  font-size: 20px;
  color: #666;
  margin-bottom: 30px;
}

.not-found a.back-home {
  display: inline-block;
  padding: 10px 30px;
  background-color: #1890ff;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.not-found a.back-home:hover {
  background-color: #40a9ff;
}

@media (max-width: 768px) {
  .error-code {
    font-size: 400px;
  }

  .error-message {
    font-size: 18px;
  }
}
</style>
